import { getClassFunction } from '@helpers/functions';

const getClass = getClassFunction('kf-o-contact-list');
const elements = document.querySelectorAll<HTMLElement>(
  getClass(undefined, {
    checkAttached: true,
  })
);

const handleContactList = (el: HTMLElement) => {
  el.dataset.eventAttached = true + '';
};

[].forEach.call(elements, handleContactList);
